import React, { useEffect, useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { Container, Row, Col, Stack } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Faq = React.forwardRef(({ scrollToContactUs }, ref) => {

const faqData = [
  {
    question: "How does FX enhance my product marketing?",
    answer: (<> FX transforms your traditional marketing by simply offering <Link to="/" target="_blank">immersive 3D experiences & AR visuals</Link> that will help your customers understand your products way better than before. This approach results in boosted engagement and makes your products stand out from the competition.</>)
  },
  {
    question: "Do I need any special equipment to use FX?",
    answer: "There is no need for any special equipment required. Your customers can access FX using any smartphones or tablets with a camera. They just need to scan the QR code and let them step inside your product education."
  },
  {
    question: "Can I customize the AR experiences on FX? ",
    answer: "Absolutely! FX offers extensive customization options for you, allowing you to tailor your AR experience to match your brand’s identity and its products' unique features. "
  },
  {
    question: "Is FX suitable for all types of products?",
    answer: "Yes! FX is versatile and can be used for a wide range of products, from customers goods to any industrial equipment and more. If you can visualize it, FX can bring it to life. "
  },
  {
    question: "How do I get started with FX?",
    answer:(<>Joining our team is easy! Just fill out the <span className="text-primary cursor-pointer"  onClick={scrollToContactUs}>contact</span> form by providing all your details and requirements in brief. Our team will then contact you with the best possible solutions with a free consultation.</>),
  },
  {
    question: "How can FX improve customer engagement? ",
    answer: "FX offers an immersive, hands-on experience, helping you keep your customers engaged longer and stay connecting with your products in a more meaningful way. This leads to higher satisfaction and conversion rates. "
  },
  {
    question: "Will you ensure security and privacy for my ideas and solutions?",
    answer:( <> Absolutely. At Futurristic Xperience (FX), we always prioritize the security & privacy of your intellectual property. We protect your ideas & solutions, ensuring they remain confidential and secure at all times.<i>Your trust is our top priority. </i></>)
  },
  {
    question: "What additional services do you offer?",
  answer: (
    <>
      We offer a wide range of services including{" "}
      <Link to="https://futurristic.com/immersive-technologies-services-and-solutions-ar-vr-mr-xr" target="_blank">AR & VR App Development</Link>,
      <Link to="https://futurristic.com/web-ar-based-marketing-solutions" target="_blank"> Web AR-based Marketing Solutions</Link>,
      <Link to="https://futurristic.com/metaverse-end-to-end-solutions" target="_blank"> Metaverse Solutions</Link>, 
       <Link to="https://futurristic.com/game-development-services-&-solutions" target="_blank"> AR/VR/XR Game Development</Link>,
       <Link to="https://futurristic.com/blockchain-integration-and-solutions" target="_blank"> Blockchain Integration</Link>, and 
       <Link to="https://futurristic.com/mobile-web-&-enterprise-development" target="_blank">  Mobile Web & Enterprise Development.</Link>
    </>
  )
}
];


  const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const offset = window.scrollY;
            if (offset > 50) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    let navbarClasses = ['navChild'];
    if (scrolled) {
        navbarClasses.push('scrolled');
    }


  return (
    <div className="FAQContent" ref={ref} data-aos="fade-up">
      <Container>
        <h1 className='text-center mb-5'>Frequently Asked Questions & FAQ</h1>
        <Row>
          <Col md={6}>

            <video className='img-fluid' autoPlay loop muted >
              <source src={"/fexperience/assets/video/faq.mp4"} type='video/mp4' />
              Your browser does not support the video tag.
            </video>
          </Col>
          <Col md={6}>
            <Accordion defaultActiveKey="0" flush>
              {faqData.map((item, index) => (
                <Accordion.Item eventKey={index.toString()} key={index}>
                  <Accordion.Header className='rounded-5 fontSize-14 font-weight'><b>{item.question}</b></Accordion.Header>
                  <Accordion.Body>
                    <Stack direction='horizontal' gap={2} style={{ alignItems: 'start' }}>
                      <p className='text-left fontSize-16'>{item.answer}</p>
                    </Stack>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Col>
        </Row>
      </Container>
    </div>
  );
});

export default Faq;
